import BaseExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'

const ExpansionPanelDetails = BaseExpansionPanelDetails

export default ExpansionPanelDetails
